import { memo } from 'react'
import Button from 'react-bootstrap/Button'
import Masonry from 'react-masonry-css'

import CardHover from '@/components/CardHover/CardHover'
import Spinner from '@/components/Spinner/Spinner'
import { update } from '@/store/cardlists/actions/update'
import { CardLabelVariantType, CardListType } from '@/types/card'

import styles from './TextView.module.scss'

type Props = {
  cardLists: CardListType[]
  labelVariant?: CardLabelVariantType
  loading: boolean
}

const TextView = ({ cardLists, labelVariant, loading }: Props) => (
  <Masonry
    breakpointCols={{
      576: 1,
      992: 2,
      1600: 3,
      default: 3,
    }}
    className={styles.myMasonryGrid}
    columnClassName={styles.myMasonryGridColumn}
  >
    {cardLists
      ?.filter((cardlist) => cardlist.cardviews.length > 0)
      .map((cardlist) => (
        <div id={cardlist.tag} key={cardlist.tag}>
          {cardLists.length > 1 && (
            <h3 className={styles.header}>
              {cardlist.header} ({cardlist.cardviews.length})
            </h3>
          )}
          <div className='d-flex flex-column'>
            {cardlist.cardviews.map((card, i) => (
              <CardHover card={card} key={i} labelVariant={labelVariant} />
            ))}
          </div>
          {cardlist.more && (
            <span>
              <br />
              <Button
                disabled={loading}
                onClick={async () => {
                  update({ moreIndex: 0 })
                }}
              >
                {loading ? <Spinner /> : 'Load More'}
              </Button>
            </span>
          )}
        </div>
      ))}
  </Masonry>
)

export default memo(TextView)
